import BasicModal from 'components/component_lib/BasicModal';
import React from 'react';

const modalStyle = {
  p: {
    fontSize: '16px',
    padding: '0 1.5rem 1.5rem',

    '&:first-of-type': {
      paddingTop: '1.5rem'
    }
  }
};

export default function CreditReportModal({ open, handleClose, provider }) {
  const isBankProduct = Boolean(provider);

  return (
    <BasicModal
      open={open}
      headerText='Credit Report Authorization'
      handleClose={handleClose}
      printId='credit-report-auth-body'
    >
      <div id='credit-report-auth-body' css={modalStyle}>
        <p>
          By continuing with the application process, you understand and agree
          that you are authorizing{' '}
          {isBankProduct
            ? `${provider}, member FDIC, and OppLoans`
            : 'OppLoans'}{' '}
          to obtain consumer reports and related information about you from one
          or more consumer reporting agencies (each a “Consumer Reporting
          Agency”). Upon request, OppLoans will provide you with the name and
          address of the Consumer Reporting Agency contacted to supply the
          report.
        </p>
        <p>
          You also authorize{' '}
          {isBankProduct ? `${provider} and OppLoans` : 'OppLoans'} to verify
          information in your application for credit, and you agree that{' '}
          {isBankProduct ? `${provider} and/or OppLoans` : 'OppLoans'} may
          contact third parties to verify any such information. You direct{' '}
          {isBankProduct ? `${provider} and/or OppLoans` : 'OppLoans'} to use
          your consumer reports to authenticate your identity, to make credit
          decisions, and for other related purposes.
        </p>
        <p>
          You expressly authorize{' '}
          {isBankProduct ? `${provider} and/or OppLoans` : 'OppLoans'} to obtain
          consumer reports from consumer reporting agencies about you when you
          apply for credit and periodically throughout the term of your credit
          product, including in the month following the month when you pay off
          or otherwise satisfy the terms of your credit product. You expressly
          authorize {isBankProduct ? `${provider} and/or OppLoans` : 'OppLoans'}{' '}
          to use the information that we obtain from such reports to, among
          other things, market refinancings and other products to you, make
          decisions related to the servicing and collection of your account,
          measure how the credit product you obtained{' '}
          {isBankProduct ? `from ${provider}` : `through OppLoans`} impacts your
          credit, perform other statistical analysis, and share information with
          you about your credit profile.
        </p>
        <p>
          You also authorize{' '}
          {isBankProduct ? `${provider} and/or OppLoans` : 'OppLoans'} to use
          obtained consumer reports to determine your eligibility for any other
          products that they may offer or that you may apply for within 30 days
          after your initial application date and initial consumer report pull.
        </p>
      </div>
    </BasicModal>
  );
}
